import React from 'react';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import App from './App';
import Login from './pages/Login';
import { PermissionsProvider } from './context/PermissionsContext';

export default function AuthenticatedApp() {
  const isAuthenticated = useIsAuthenticated();
  const { inProgress } = useMsal();

  // Show loading state while checking authentication
  if (inProgress === 'login' || inProgress === 'acquire-token' || inProgress === 'logout') {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        background: '#f5f5f5'
      }}>
        <div style={{
          textAlign: 'center'
        }}>
          <div style={{
            fontSize: '48px',
            marginBottom: '20px'
          }}>⏳</div>
          <p style={{ color: '#666', fontSize: '16px' }}>Loading...</p>
        </div>
      </div>
    );
  }

  // Show login page if not authenticated
  if (!isAuthenticated) {
    return <Login />;
  }

  // Show main app if authenticated, wrapped in permissions provider
  return (
    <PermissionsProvider>
      <App />
    </PermissionsProvider>
  );
}
